import styled from '@emotion/styled';
import Typography from 'components/Typography/Typography';
import { theme } from 'theme';

export const DescirptionColumn = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 20px;
`;

export const DescriptionGrid = styled.div`
  width: 100%;
  display: flex;
  padding-top: 20px;
  padding-bottom: 20px;
  ${DescirptionColumn} {
    width: 33.33%;
    &:not(:first-of-type) {
      padding-left: 20px;
      border-left: 1px solid ${theme.palette.grey['50']};
    }
  }
`;

export const DescriptionLabel = styled(Typography)`
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: ${theme.palette.grey['A400']};
`;
export const DescriptionValue = styled(Typography)<{ isNote?: boolean }>`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: ${theme.palette.primary.main};
  padding-top: 6px;
  line-break: ${({ isNote }) => (isNote ? 'normal' : 'anywhere')};
`;

export const GpsWrapper = styled.div`
  display: flex;
  padding: 16px 0;
  border-bottom: 1px solid ${theme.palette.grey['50']};
`;

export const GpsLabel = styled(Typography)`
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  height: 22px;
  padding: 0px 4px 0 8px;
  background: ${theme.palette.secondary?.main};
  color: #e82011; // Gensler brand color
  border-radius: 16px;
  display: flex;
  align-items: center;
  gap: 2px;
  svg {
    position: relative;
    top: -1px;
    font-size: 11px;
  }
`;
